// Attach the signed-in user's Supabase token to every request to our API.
// The backend checks it on any request that names a user (see src/auth.py),
// so pages don't each need to remember to send it.
import { supabase } from './supabaseclient';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/$/, '');

export function installAuthFetch() {
  if (window.__vsAuthFetch) return;
  window.__vsAuthFetch = true;
  const original = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    if (!url.startsWith(API)) return original(input, init);

    let token = '';
    try {
      const { data } = await supabase.auth.getSession();
      token = data?.session?.access_token || '';
    } catch { /* not signed in — guest requests need no token */ }
    if (!token) return original(input, init);

    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    return original(input, { ...init, headers });
  };
}
